import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const CollapsableContent = styled.div`
    border: 1px solid ${theme.colors.border.muted};
    border-bottom-left-radius: ${theme.radii[6]};
    border-bottom-right-radius: ${theme.radii[6]};
    border-top: none;
`;
